var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.1667 28.4167C34.1113 28.4167 32.14 27.6002 30.6866 26.1467C29.2332 24.6933 28.4167 22.7221 28.4167 20.6667V10.3333H18.0834C16.7131 10.3333 15.3989 10.8777 14.43 11.8466C13.4611 12.8156 12.9167 14.1297 12.9167 15.5V49.0833C12.9167 50.4536 13.4611 51.7678 14.43 52.7367C15.3989 53.7057 16.7131 54.25 18.0834 54.25H41.3334C42.7037 54.25 44.0178 53.7057 44.9868 52.7367C45.9557 51.7678 46.5 50.4536 46.5 49.0833V28.4167H36.1667ZM31 20.6667C31 22.037 31.5444 23.3511 32.5133 24.3201C33.4823 25.289 34.7964 25.8333 36.1667 25.8333H45.4409L31 11.3925V20.6667ZM18.0834 7.75H31L49.0834 25.8333V49.0833C49.0834 51.1388 48.2669 53.11 46.8135 54.5634C45.36 56.0168 43.3888 56.8333 41.3334 56.8333H18.0834C16.0279 56.8333 14.0567 56.0168 12.6033 54.5634C11.1499 53.11 10.3334 51.1388 10.3334 49.0833V15.5C10.3334 13.4446 11.1499 11.4733 12.6033 10.0199C14.0567 8.56652 16.0279 7.75 18.0834 7.75Z",
    fill: "#FCB450"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.3571c7b9204e1ab1b4ce4c2213bc29ed.svg";
export { ForwardRef as ReactComponent };